module.exports = __webpack_public_path__ + "static/media/insurance-payout.d4ba2596.svg";